export function detectInputType(value: string): "email" | "phone" {
  if (!value) return "email";
  
  // Strip common phone formatting characters
  const cleaned = value.replace(/[\s\-()]/g, '');
  
  // A valid phone number contains only digits with an optional leading '+'
  const phonePattern = /^\+?\d+$/;

  if (phonePattern.test(cleaned)) return "phone";
  return "email";
}
